import React from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import { Box, Button, CircularProgress } from "@mui/material";
import { PasswordWrapper, WalletContainer, WalletHeader } from "../walletStyles";
import { PasswordField } from "../../../components/Form/FormComponents";
import { toggleActivateWalletModal } from "../../../redux/WalletSlice";

const CreatePin = ({ handleChange, newPin, confirmPin, onCreatePin, isLoading, accessPin, oldPin }) => {
	const dispatch = useDispatch();

	return (
		<WalletContainer>
			<>
				<WalletHeader
					headerText={`${accessPin ? "Update" : "Create"} Transaction Pin`}
					onCloseModal={() => dispatch(toggleActivateWalletModal(false))}
					context={`You need to ${accessPin ? "update your" : "create a"} 4-Digit transaction pin`}
				/>
				<Box display='flex' flexDirection='column' gap={1.5} marginTop={1}>
					{accessPin && (
						<PasswordWrapper>
							<label htmlFor='oldPin'>Old Pin</label>
							<PasswordField
								name='oldPin'
								value={oldPin}
								handleChange={handleChange}
								required={true}
								context='pin'
							/>
						</PasswordWrapper>
					)}
					<PasswordWrapper>
						<label htmlFor='oldPin'>New Pin</label>
						<PasswordField
							name='newPin'
							value={newPin}
							handleChange={handleChange}
							required={true}
							context='pin'
						/>
					</PasswordWrapper>
					<PasswordWrapper>
						<label htmlFor='oldPin'>Confirm Pin</label>
						<PasswordField
							name='confirmPin'
							value={confirmPin}
							handleChange={handleChange}
							required={true}
							context='pin'
						/>
					</PasswordWrapper>
					<Button
						variant='contained'
						color='primary'
						sx={{ borderRadius: "6px", marginTop: "10px" }}
						disabled={isLoading}
						onClick={onCreatePin}>
						{isLoading ? <CircularProgress color='primary' size={30} thickness={5} /> : "Submit"}
					</Button>
				</Box>
			</>
		</WalletContainer>
	);
};

export default CreatePin;

CreatePin.propTypes = {
	handleChange: PropTypes.func,
	newPin: PropTypes.string,
	confirmPin: PropTypes.string,
	onCreatePin: PropTypes.func,
	isLoading: PropTypes.bool,
	oldPin: PropTypes.string,
	accessPin: PropTypes.string,
};
